import { Item } from '../types/Item'

//Initial data
export const items: Item[] = [
  {
    date: new Date(2024, 0, 12),
    category: 'salary',
    title: 'Freelancer',
    value: 1300
  },

  {
    date: new Date(2024, 0, 15),
    category: 'food',
    title: 'Big Mac',
    value: 31.8
  },

  {
    date: new Date(2024, 2, 19),
    category: 'rent',
    title: 'Aluguel Apt',
    value: 1900
  },

  {
    date: new Date(2024, 1, 1),
    category: 'savings',
    title: 'Depósito na poupança',
    value: 500
  },

  {
    date: new Date(2024, 1, 5),
    category: 'groceries',
    title: 'Supermercado',
    value: 150
  },

  {
    date: new Date(2024, 0, 15),
    category: 'transportation',
    title: 'Uber',
    value: 20
  },

  {
    date: new Date(2024, 1, 2),
    category: 'health',
    title: 'Consulta Médica',
    value: 120
  },

  {
    date: new Date(2024, 0, 15),
    category: 'entertainment',
    title: 'Cinema',
    value: 25
  },

  {
    date: new Date(2024, 1, 5),
    category: 'utilities',
    title: 'Conta de Luz',
    value: 120
  },

  {
    date: new Date(2024, 1, 22),
    category: 'investments',
    title: 'Compra de ações',
    value: 300
  },

  {
    date: new Date(2024, 1, 8),
    category: 'education',
    title: 'Curso online de programação',
    value: 50
  },

  {
    date: new Date(2024, 0, 15),
    category: 'clothing',
    title: 'Camiseta',
    value: 50
  },

  {
    date: new Date(2024, 1, 14),
    category: 'gifts',
    title: 'Presente de aniversário',
    value: 70
  },

  {
    date: new Date(2024, 1, 1),
    category: 'other',
    title: 'Despesa variável',
    value: 50
  },

  {
    date: new Date(2023, 11, 24),
    category: 'entertainment',
    title: 'Ceia de natal',
    value: 120
  }
];